/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_SuccessInputs */

const en_register_onboarding_personal_info_success = /** @type {(inputs: Register_Onboarding_Personal_Info_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume processed successfully. The fields below have been pre-filled.`)
};

const de_register_onboarding_personal_info_success = /** @type {(inputs: Register_Onboarding_Personal_Info_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf erfolgreich verarbeitet. Die Felder unten wurden vorausgefüllt.`)
};

/**
* | output |
* | --- |
* | "Resume processed successfully. The fields below have been pre-filled." |
*
* @param {Register_Onboarding_Personal_Info_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_success = /** @type {((inputs?: Register_Onboarding_Personal_Info_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_success(inputs)
	return en_register_onboarding_personal_info_success(inputs)
});